import IconArticle from "images/icon-document.svg";
import IconVideo from "images/icon-video.svg";
import IconSlides from "images/icon-slides.svg";

export default {
  library: {
    Topics: [
      { text: "Agility", value: "agility" },
      { text: "Culture", value: "culture" },
      { text: "Design Thinking", value: "design-thinking" },
      {
        text: "Diversity, Equity, Inclusion and Belonging",
        value: "diversity-equity-inclusion-belonging",
      },
      {
        text: "Employee Experience and Engagement",
        value: "employee-experience-and-engagement",
      },
      { text: "Future of Work", value: "future-of-work" },
      { text: "HR Strategy", value: "hr-strategy" },
      { text: "Innovation", value: "innovation" },
      { text: "Job seekers", value: "job-seekers" },
      { text: "Leadership", value: "leadership" },
      { text: "Learning and Development", value: "learning-and-development" },
      { text: "Marketing and Branding", value: "marketing-and-branding" },
      {
        text: "People Science and People Analytics ",
        value: "people-science-analytics",
      },
      { text: "Performance Management", value: "performance-management" },
      { text: "Recruitment and Talent", value: "recruitment-and-talent" },
      { text: "Remote Work", value: "remote-work" },
      {
        text: "Strategy and Transformation",
        value: "strategy-and-transformation",
      },
      { text: "Technology", value: "technology" },
      { text: "Wellness and Wellbeing", value: "wellness-and-wellbeing" },
    ],
    "Content type": [
      {
        text: "Article",
        value: "article",
        icon: IconArticle,
      },
      {
        text: "Video",
        value: "video",
        icon: IconVideo,
      },
      {
        text: "Podcast",
        value: "podcast",
        icon: IconSlides,
      },
    ],
    // Language: [
    //   {
    //     text: "English",
    //     value: "english",
    //   },
    //   {
    //     text: "Spanish",
    //     value: "spanish",
    //   },
    //   {
    //     text: "Portuguese",
    //     value: "portuguese",
    //   },
    // ],
  },
  events: {
    Topics: [
      { text: "Agility", value: "agility" },
      { text: "Culture", value: "culture" },
      { text: "Design Thinking", value: "design-thinking" },
      {
        text: "Diversity, Equity, Inclusion and Belonging",
        value: "diversity-equity-inclusion-belonging",
      },
      {
        text: "Employee Experience and Engagement",
        value: "employee-experience-and-engagement",
      },
      { text: "Future of Work", value: "future-of-work" },
      { text: "HR Strategy", value: "hr-strategy" },
      { text: "Innovation", value: "innovation" },
      { text: "Job seekers", value: "job-seekers" },
      { text: "Leadership", value: "leadership" },
      { text: "Learning and Development", value: "learning-and-development" },
      { text: "Marketing and Branding", value: "marketing-and-branding" },
      {
        text: "People Science and People Analytics ",
        value: "people-science-analytics",
      },
      { text: "Performance Management", value: "performance-management" },
      { text: "Recruitment and Talent", value: "recruitment-and-talent" },
      { text: "Remote Work", value: "remote-work" },
      {
        text: "Strategy and Transformation",
        value: "strategy-and-transformation",
      },
      { text: "Technology", value: "technology" },
      { text: "Wellness and Wellbeing", value: "wellness-and-wellbeing" },
    ],
  },
  ConferenceLibrary: {
    year: ["2020", "2021"],
  }
};
